<template>
  <div class="over">
    <!-- TEMPERATURES CONTAINER -->
    <div id="temps" class="temp-wrapper noselect">
      <div class="infoi" v-show="!loaded || this.getDispList.length == 0">
        <h2 v-if="this.getDispList.length == 0 && loaded">
          {{ $t("message.noDataInRange") }}...
        </h2>
        <h2 v-else>{{ $t("message.loading") }}...</h2>
      </div>
      <div class="main-wrap over-info">
        <h2>Frequency Response</h2>
        <p class="first-block">{{ $t("message.dataOfSelectedDevice") }}</p>
        <img @click="downloadFFT" class="download-btn" src="../../../../public/assets/download.svg" />
      </div>
      <div class="disp-plot-wrapper">
        <LinePlot
          :height="this.plotHeight"
          :traces="this.getTraces"
          :xTitle="$t('dataType.frequency') + ' (Hz)'"
          :yTitle="$t('dataType.amplitudeSpectrum') + ' (mm/Hz)'"
          :xRange="[0, 20]"
          v-if="this.getFFT"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LinePlot from "../../graphs/LinePlot.vue";
import { mapGetters, mapActions } from "vuex";
import download from "../../../helpers/download.js";

var mql = window.matchMedia("screen and (max-width: 1499px)");

export default {
  name: "fft-module",
  components: {
    LinePlot,
  },
  data() {
    return {
      loaded: false,
      firstExec: true,
      plotHeight: 490,
      today: new Date(Date.now()).toLocaleString().split(",")[0],
    };
  },
  methods: {
    ...mapActions({
      fetchFFT: "eventdetails/fetchFFT",
    }),
    sensorSelected: function(value) {
      this.setSelectedSensor(value);
    },
    dateSelected: function(dateRange) {
      this.setDateRange(dateRange);
    },
    responsiveScreenHandler: function(e) {
      // Modifico l'attributo 'height' del grafico in base alla dimensione della finestra, vedere 'mql'
      if (e.matches) {
        this.plotHeight = 350;
      } else {
        this.plotHeight = 490;
      }
    },
    /* Scarico .CSV */
    downloadFFT () {
      if (this.loaded) {
        let events = [];
        for (let i = 0; i < this.getFFT.vettoreF.length; i++) {
          events.push({
            eui: this.getSelectedSensor.eui.substr(this.getSelectedSensor.eui.length - 4),
            frequency: this.getFFT.vettoreF[i],
            amplitude:this.getFFT.amplitude[i],
          })
        }
        let headers = {
          eui: "Device",
          frequency: "Frequency",
          amplitude: "Amplitude",
        };
        let title = "FFT " + this.getSelectedSensor.eui.substr(this.getSelectedSensor.eui.length - 4);

        download.exportCSVFile(
          headers,
          events,
          title
        )
      }
    }
  },
  computed: {
    ...mapGetters({
      getFFT: "eventdetails/getFFT",
      getDispDetails: "eventdetails/getDisplacementDetails",
      getDispList: "eventdetails/getDisplacementList",
      getSelectedSensor: "eventdetails/getSelectedSensor"
    }),
    getTraces: function() {
      return [
        {
          uid: "34534sa",
          line: {
            color: "rgb(17, 205, 239)",
            width: 4,
          },
          mode: "lines",
          name: "Peaks Line",
          type: "scatter",
          x: this.getFFT.vettoreF,
          y: this.getFFT.amplitude,
          xaxis: "x",
          yaxis: "y",
          opacity: 0.9,
          textfont: {},
        },
      ];
    },
  },
  async mounted() {
    // Verifico la dimensione della finestra e aggiungo listener per gestire il ridimensionamento
    this.responsiveScreenHandler(mql);
    mql.addListener(this.responsiveScreenHandler);
  },
  watch: {
    getDispDetails: {
      handler: async function() {
        // Init and Date already ok
        this.loaded = false;
        await this.fetchFFT();
        this.loaded = true;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.over {
  min-width: 600px;
  width: 100%;
  column-gap: 2%;
  display: grid;
  grid-template-columns: 49% 49%;
  z-index: 2;
}

.temp-wrapper {
  position: relative;
  height: 580px;
  margin-top: 30px;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}

.download-btn{
  cursor: pointer;
  grid-row: 1/3;
  height: 18px;
  justify-self: end;
  margin-right: 32px;
  background-color: rgb(33, 150, 243);
  padding: 10px;
  grid-column: 2;
  border-radius: 10px;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .temp-wrapper {
    height: 430px;
  }
}
#temps {
  width: 100%;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}

#tx-trend {
  grid-row: 1;
  grid-column: 1;
}

#temp-trend {
  grid-row: 1;
  grid-column: 2;
}

.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}
.infoi {
  z-index: 9;
  background-color: black;
  opacity: 0.7;
  border-radius: 10px;
}
.infoi > h2 {
  margin: auto;
}

.main-wrap {
  margin-top: 20px;
  display: grid;
  margin-left: 60px;
  grid-template-columns: max-content;
}
.over-info > h2 {
  font-size: 1em;
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info > p {
  font-size: 0.8em;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info {
  text-align: left;
  position: relative;
}
</style>
